import React from "react";
import styles from "../styles/skills.css";
import {
  MdOutlineDesignServices,
  MdOutlineDeveloperMode,
} from "react-icons/md";
import { motion } from "framer-motion";

const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ type: "just", duration: 0.5 }}
      className="skills"
    >
      <div className="container">
        {/* <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ type: "just", duration: 0.5 }}
          className="one"
        >
          <MdOutlineDesignServices className="skills-icons" />
          <h2 className="skills-top-heading" style={{ fontWeight: "700" }}>
            Designer
          </h2>
          <p className="caption skill-del">
            I value simple content structure, clean design patterns, and
            thoughtful interactions.
          </p>
          <p className="skills-heading caption">Things I enjoy designing:</p>
          <p className="caption">UX, UI, Web, Apps, Logos</p>
          <p className="skills-heading caption">Design Tools:</p>
          <ul>
            <li className="caption">Figma</li>
            <li className="caption">Canva</li>
            <li className="caption">Pixellab</li>
            <li className="caption">Font Awesome</li>
            <li className="caption">React Icons</li>
          </ul>
        </motion.div>
        <hr style={{ opacity: "20%" }} /> */}
        <motion.div
        initial={{opacity: 0, x: 50}}
        whileInView={{opacity: 1, x:0}}
        transition={{type: "just",duration: 0.5}}
        className="two">
          <MdOutlineDeveloperMode className="skills-icons" />
          <h2 className="skills-top-heading" style={{ fontWeight: "700" }}>
            IOS Developer
          </h2>
          <p className="caption skill-del" style={{maxWidth: ""}}>
            I like to code things from scratch, and enjoy bringing ideas to life
            with my coding skills.
          </p>
          <p className="skills-heading caption">Languages I speak:</p>
          <p className="caption">Swift, Python, Javascript, SQL</p>
          <p className="skills-heading caption">Dev Tools:</p>
          <ul>
            <li className="caption">Xcode</li>
            <li className="caption">MVVM</li>
            <li className="caption">MVC</li>
            <li className="caption">AutoLayout</li>
            <li className="caption">SwiftUI</li>
            <li className="caption">CoreData</li>
            <li className="caption">CoccaPods</li>
            <li className="caption">XCTest</li>
            <li className="caption">URLSession</li>
            <li className="caption">Codable</li>
            <li className="caption">Git</li>
            <li className="caption">Swift Package Manager</li>
            <li className="caption">RESTFUL API's</li>
          </ul>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Skills;
